export class RemovalsMetrics {
  AVERAGE_TSI: number;
  MAX_TSI: number;
  MIN_TSI: number;
  STDDEV_TSI: number;
  SUM_TSI: number;
  AVERAGE_CSI: number;
  MAX_CSI: number;
  MIN_CSI: number;
  STDDEV_CSI: number;
  SUM_CSI: number;
  AVERAGE_TSO: number;
  MAX_TSO: number;
  MIN_TSO: number;
  STDDEV_TSO: number;
  SUM_TSO: number;
  AVERAGE_CSO: number;
  MAX_CSO: number;
  MIN_CSO: number;
  STDDEV_CSO: number;
  SUM_CSO: number;
  AVERAGE_TSR: number;
  MAX_TSR: number;
  MIN_TSR: number;
  STDDEV_TSR: number;
  SUM_TSR: number;
  AVERAGE_CSR: number;
  MAX_CSR: number;
  MIN_CSR: number;
  STDDEV_CSR: number;
  SUM_CSR: number;
}
